import styled from "styled-components";
import notCourseImage from "../../assets/images/mca-lab-transparent.png";

export const Thumbnail = styled.div<{iscard: boolean, url: string}>`
  width: ${({iscard}) => iscard ? '90px' : '100%'};
  height: ${({iscard}) => iscard ? '90px' : '100%'};
  background-image: url(${({ url }) => url ? url : notCourseImage });
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  /* background-size: ${({iscard, url}) => iscard || !url ? 'contain' : 'contain'}; */
`;